import { z } from 'zod/v4';

import { columns } from './columns';

export * from './enums';
export * from './results-metadata';

export const priceSegmentSchema = z.object(columns);

export type PriceSegment = z.output<typeof priceSegmentSchema>;
